export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_66_Password.f887f2b9.svg";